'use strict';

let requireOrNull;
if (process.env.WEBPACK) {
  requireOrNull = require;
} else {
  requireOrNull = str => str;
}

const critModules = [
  {
    name: 'GetawaysCalendar',
    module: requireOrNull('../../../../modules/getaways/frontend/calendar'),
  },
  {
    name: 'GetawaysSearchWidget',
    module: requireOrNull(
      '../../../../modules/getaways/frontend/search_widget'
    ),
  },
  {
    name: 'GetawaysFinePrint',
    module: requireOrNull(
      '../../../../modules/getaways_v2/frontend/getaways_fineprint_handler'
    ),
    featureCheck: serverObj => serverObj.isGetawaysDealPageV2,
  },
  {
    name: 'GetawaysBooking',
    module: requireOrNull(
      '../../../../modules/getaways_v2/frontend/getaways_bookingbutton_handler'
    ),
    featureCheck: serverObj => serverObj.isGetawaysDealPageV2,
  },
  {
    name: 'GetawaysTripAdvisor',
    module: requireOrNull('../../../../modules/getaways/frontend/trip_advisor'),
    featureCheck: serverObj => serverObj.tripAdvisor,
  },
];

const nonCritModules = [
  {
    name: 'AsyncScripts',
    module: requireOrNull('../async_scripts/getaways'),
  },
  {
    name: 'Merchant',
    module: requireOrNull('../../../../modules/merchant/frontend/lazy_load'),
    featureCheck: serverObj =>
      serverObj.merchant &&
      serverObj.merchant.clientSideMerchantLocations &&
      serverObj.loadSwitch &&
      serverObj.loadSwitch.shouldLoadLazyLoadMerchantLocations,
  },
];

module.exports = { critModules, nonCritModules };
